import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Store } from '@ngrx/store';

import { ProjectDataActions } from '../../store/project-data/project-data.actions';
import type { TreeEntity } from '../../../core/models/entity.model';
import type { EntityEditorPropertyChangedEvent } from '../../../entity-editor/models/entity-editor-property-changed.event';

@Component({
  selector: 'app-project-form',
  templateUrl: './project-form.component.html',
  styleUrls: ['./project-form.component.scss'],
  standalone: false
})
export class ProjectFormComponent {
  isFormValid = false;

  @Input() projectEntity: TreeEntity;

  @Output() submitForm = new EventEmitter<void>();

  constructor(private store: Store) {}

  propertyChanged(property: EntityEditorPropertyChangedEvent): void {
    this.store.dispatch(
      ProjectDataActions.update_project_start({
        entityId: this.projectEntity.Id,
        propertyKey: property.propertyKey,
        newValue: property.value,
        measurementUnit: property.measurementUnit
      })
    );
  }
}
